export default __webpack_public_path__ + "17a61d784b032b6ae0b2a2cd34d64233.svg";